import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BACKEND_API_URL } from "../../config";

const initialState = {
  data: {
      _option: '',
      agencyWebsite: [{ description: '', link: '' }]
    }, 
  status: 'idle', // 'idle' | 'loading' | 'success' | 'failed'
  loading: false,
  error: null,
}

export const fetchInitialState = createAsyncThunk(
  'OccupationalLicense/fetch', 
  async (data, { getState, dispatch }) => {
    const {token} = getState().navigator;
      try {
        const response = await fetch(`${BACKEND_API_URL}/api/onboarding/occupational_license?token=${token}`);
        if (!response.ok) {
          throw new Error('Failed to fetch initial state');
        }
        const initialState = await response.json();
        // // console.log(initialState);
        return initialState;
      } catch (error) {
        console.error('Error fetching initial state:', error);
        return initialState.data
      }
    
  })



// Create New 
export const SubmitOccupationalLicense = createAsyncThunk(
    'OccupationalLicense/submit',
    async (data, { getState, dispatch, rejectWithValue }) => {
        try {
          const {token, currentStep} = getState().navigator;
          if (data._option === '') {
            return rejectWithValue('Please select the option.');
          }
          else if (data._option === 'Yes') {
              const allFieldsFilled = data.agencyWebsite.every(set => set.description.trim() !== '' && set.link.trim() !== '');
              const allLinksValid = data.agencyWebsite.every(set => set.link.endsWith('.com') || set.link.endsWith('.biz'));

              if (!allFieldsFilled) {
                  return rejectWithValue('Please fill all the inputs!');
              }

              if (!allLinksValid) {
                  return rejectWithValue('All links must end with .com or .biz');
              }
          }
          const response = await fetch(`${BACKEND_API_URL}/api/onboarding/occupational_license?token=${token}`, {
              method: 'POST',
              body: JSON.stringify({'data': data, 'current_step': currentStep}),
              headers: {
                  'Content-Type': 'application/json',
              }
          });
          const response_data =  await response.json();
          // Handle the response data
          // // console.log('Form submitted successfully', response_data);
    
          return response_data.data;
        } catch (error) {
          // Handle submission errors
          console.error('Form submission error', error);
          // Throw an error for the rejected action
          return error;
        }
      }
)


// Slice

export const occupationalLicenseSlice = createSlice({
    name: 'OccupationalLicense',
    initialState,
    reducers: {
      updateOccupationalLicenseOption: (state, action) => {
        state.data._option = action.payload;
        if (action.payload === 'No') {
            state.data.agencyWebsite = []
        }
        else if (action.payload === 'Yes') {
            state.data.agencyWebsite = [{ description: '', link: '' }]
        }
      },
      updateOccupationalLicenseAgencyWebsite: (state, action) => {
        const { index, field, value } = action.payload;
        state.data.agencyWebsite[index][field] = value;
      },
      addOccupationalLicenseAgencyWebsite: (state, action) => {
        if (state.data.agencyWebsite.length < 10) {
          state.data.agencyWebsite.push({ description: '', link: '' });
        }
      },
      deleteOccupationalLicenseAgencyWebsite: (state, action) => {
        state.data.agencyWebsite.splice(action.payload.index, 1);
      }
    },
    extraReducers: (builder) => {
        builder
          // FETCH
          // CREATE or UPDATE
          .addCase(fetchInitialState.pending, (state) => {
            state.loading = true;
          })
          .addCase(fetchInitialState.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
          })
          .addCase(fetchInitialState.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })

          // CREATE or UPDATE
          .addCase(SubmitOccupationalLicense.pending, (state) => {
            state.loading = true;
          })
          .addCase(SubmitOccupationalLicense.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
          })
          .addCase(SubmitOccupationalLicense.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })
      },
  });


export const { updateOccupationalLicenseOption, updateOccupationalLicenseAgencyWebsite, addOccupationalLicenseAgencyWebsite, deleteOccupationalLicenseAgencyWebsite } = occupationalLicenseSlice.actions;

export default occupationalLicenseSlice.reducer;
  